import { useEffect } from 'react';
import { useIdQuestion } from './useIdQuestion';
import { useSurveyContext } from '../context/useSurveryContext';
import { surveysConsultUseCase } from '../domain/use-cases/surveys.use-case';

export default function useService() {
	const idQuestion = useIdQuestion();
	const { setSurvey, setCurrentQuestion } = useSurveyContext();

	const getQuestions = async () => {
		try {
			const body = { idEncuesta: idQuestion };
			const data = await surveysConsultUseCase(body);
			if (data.code !== '0000') {
				//setError(response?.data?.message);
			} else {
				setSurvey(data?.data);
				setCurrentQuestion(data?.data?.PREGUNTAS[0]);
			}
		} catch (error) {
			//console.error('Error en la petición:', error);
		}
	};

	useEffect(() => {
		getQuestions();
	}, []);

	return { getQuestions };
}
